(function () {
  const genericTerms = [
    'cat food',
    'digestive',
    'dog food',
    'dry cat food',
    'dry dog food',
    'dry food',
    'hairball',
    'kitten food',
    'large dog food',
    'milk',
    'puppy food',
    'senior cat food',
    'senior dog food',
    'small dog food',
    'wet cat food',
    'wet dog food',
    'wet food',
    'wet kitten food',
    'wet puppy food',
    'sensitive cat food'
  ];

  const brandedTerms = [
    'royal canin',
    'royal canine',
    'royal cannin',
    'royal canan',
    'royal cainin',
    'royal canning',
    'royal canin dog food',
    'royal canin cat food'
  ];

  function normalise(value) {
    return String(value || '').trim().toLowerCase().replace(/\s+/g, ' ');
  }

  function classifySearch(term) {
    const cleanTerm = normalise(term);

    if (brandedTerms.includes(cleanTerm)) return 'royal_canin_branded';
    if (genericTerms.includes(cleanTerm)) return 'royal_canin_generic';

    return null;
  }

  function fireRoyalCaninSearch(term) {
    const cleanTerm = normalise(term);
    const type = classifySearch(cleanTerm);

    if (!type) return;

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'royal_canin_jbp_search',
      search_term: cleanTerm,
      search_type: type,
      page_path: window.location.pathname,
      page_url: window.location.href
    });

    console.log('Royal Canin JBP Search Fired:', cleanTerm, type);
  }

  function getSearchInputValue(element) {
    const form = element.closest('form');
    const input =
      form?.querySelector('input[name="q"]') ||
      form?.querySelector('input[type="search"]') ||
      document.querySelector('input[name="q"]') ||
      document.querySelector('input[type="search"]');

    return input ? input.value : '';
  }

  document.addEventListener('submit', function (event) {
    const form = event.target;
    if (!form) return;

    const term = getSearchInputValue(form);
    fireRoyalCaninSearch(term);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;

    const target = event.target;
    if (!target) return;

    if (
      target.matches('input[name="q"]') ||
      target.matches('input[type="search"]') ||
      target.closest('form[action*="/search"]')
    ) {
      fireRoyalCaninSearch(target.value);
    }
  }, true);

  document.addEventListener('click', function (event) {
    const button = event.target.closest('button, input[type="submit"], a');
    if (!button) return;

    const term = getSearchInputValue(button);
    fireRoyalCaninSearch(term);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    const params = new URLSearchParams(window.location.search);
    const termFromUrl = params.get('q');

    if (termFromUrl) {
      fireRoyalCaninSearch(termFromUrl);
    }
  });
})();